<template>
  <el-dialog
    :title="dialogTitle"
    :visible="dialogVisible"
    v-if="dialogVisible"
    @opened="opened"
    @close="dialogClose"
    width="1024px"
    class="view_scroll-box7"
    :close-on-click-modal="false"
  >
    <!-- @tab-click="tabclick" -->
    <el-tabs type="card" :before-leave="leaveTab" id="userinfo">
      <el-tab-pane label="个人信息">
        <span slot="label">个人信息</span>
        <div class="tab-content">
          <div class="tab-from-box">
            <el-form :model="form" ref="form" class="form-box" :disabled="true">
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="11">
                  <el-form-item
                    label="用户名"
                    :label-width="formLabelWidth"
                    prop="LoginName"
                  >
                    <el-input
                      v-model="form.LoginName"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item
                    label="姓名"
                    :label-width="formLabelWidth"
                    prop="NickName"
                  >
                    <el-input
                      v-model="form.NickName"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="11">
                  <el-form-item
                    label="身份证明号码"
                    :label-width="formLabelWidth"
                    prop="IDNumber"
                  >
                    <el-input
                      v-model="form.IDNumber"
                      autocomplete="off"
                      maxlength="18"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item
                    label="手机号码"
                    :label-width="formLabelWidth"
                    prop="Mobile"
                  >
                    <el-input
                      v-model="form.Mobile"
                      autocomplete="off"
                      maxlength="11"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="11">
                  <el-form-item
                    label="邮箱"
                    :label-width="formLabelWidth"
                    prop="Email"
                  >
                    <el-input
                      v-model="form.Email"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item
                    label="备注"
                    :label-width="formLabelWidth"
                    prop="Remark"
                  >
                    <el-input
                      v-model="form.Remark"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row type="flex" class="row-bg" justify="space-between">
                <el-col :span="11">
                  <el-form-item
                    label="用户类型"
                    :label-width="formLabelWidth"
                    prop="UserType"
                  >
                    <el-input
                      v-model="form.UserTypeStr"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11">
                  <el-form-item
                    v-if="form.UserType == 1"
                    label="所属集团"
                    :label-width="formLabelWidth"
                    prop="OwnedGroupCode"
                  >
                    <el-input
                      v-model="groupModel.GroupName"
                      autocomplete="off"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    v-if="form.UserType == 2"
                    label="所属检测站"
                    :label-width="formLabelWidth"
                    prop="OwnedStationCode"
                  >
                    <el-input
                      v-model="form.StationName"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row
                type="flex"
                class="row-bg"
                justify="space-between"
                v-if="
                  form.UserType == 2 ||
                  (form.UserType == 1 && GroupInfos != groupModel.GroupName)
                "
              >
                <el-col :span="24">
                  <el-form-item
                    :label="form.UserType == 2 ? '所属集团' : '所属集团明细'"
                    :label-width="formLabelWidth"
                    prop="GroupInfos"
                  >
                    <el-input
                      v-model="GroupInfos"
                      autocomplete="off"
                      maxlength="50"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-if="isBind == true">
                <el-col :span="24"> <el-divider></el-divider></el-col>
              </el-row>
              <el-row
                type="flex"
                class="row-bg"
                justify="space-between"
                v-if="isBind == true"
              >
                <el-col :span="10">
                  <el-form-item
                    label="微信昵称"
                    :label-width="formLabelWidth"
                    prop="NickName"
                  >
                    <el-input
                      v-model="weChatform.NickName"
                      autocomplete="off"
                      maxlength="50"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="1">
                  <img
                    v-if="weChatform.AvatarUrl != ''"
                    :src="weChatform.AvatarUrl"
                    width="40"
                    height="40"
                /></el-col>
                <el-col :span="13"></el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="检测站信息" v-if="form.UserType == 2">
        <span slot="label">检测站信息</span>
        <div class="tab-content">
          <div class="tab-from-box">
            <el-form
              :model="model"
              ref="form"
              class="form-box"
              :disabled="true"
            >
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="名称"
                    :label-width="formLabelWidth"
                    prop="StationName"
                  >
                    <el-input
                      v-model="model.StationName"
                      autocomplete="off"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="简称"
                    :label-width="formLabelWidth"
                    prop="StationShortName"
                  >
                    <el-input
                      v-model="model.StationShortName"
                      autocomplete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="联系电话"
                    :label-width="formLabelWidth"
                    prop="ContactNumber"
                  >
                    <el-input
                      v-model="model.ContactNumber"
                      autocomplete="off"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item
                    label="联系人"
                    :label-width="formLabelWidth"
                    prop="Contact"
                  >
                    <el-input
                      v-model="model.Contact"
                      maxlength="20"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="手机号码"
                    :label-width="formLabelWidth"
                    prop="Mobile"
                  >
                    <el-input
                      v-model="model.Mobile"
                      maxlength="15"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item
                    label="客服电话"
                    :label-width="formLabelWidth"
                    prop="ServiceTel"
                  >
                    <el-input
                      v-model="model.ServiceTel"
                      maxlength="50"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="邮箱"
                    :label-width="formLabelWidth"
                    prop="Email"
                  >
                    <el-input
                      v-model="model.Email"
                      maxlength="50"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="检验机构编号"
                    :label-width="formLabelWidth"
                    prop="StationSerialNumber"
                  >
                    <el-input
                      v-model="model.StationSerialNumber"
                      maxlength="50"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="地址"
                    :label-width="formLabelWidth"
                    prop="Address"
                  >
                    <el-input
                      v-model="model.Address"
                      autocomplete="off"
                      maxlength="500"
                      placeholder="请精确到市，否则经纬度会解析失败"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="4" style="text-align: center">
                  <el-button
                    v-auth="'humanResources_station_getAddress'"
                    @click="getAddressLocation()"
                    :disabled="getAddressBtnDisabled"
                    >{{ getAddressBtnText }}</el-button
                  >
                </el-col> -->

                <el-col :span="12">
                  <el-form-item
                    label="经纬度"
                    :label-width="formLabelWidth"
                    prop="LocationLng"
                  >
                    <el-input
                      :value="model.LocationLng + ',' + model.LocationLat"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="外检后引车"
                    :label-width="formLabelWidth"
                    prop="DriverStartFromVisualInspection"
                  >
                    <el-select
                      v-model="model.DriverStartFromVisualInspection"
                      default-first-option
                    >
                      <el-option
                        v-for="item in DriverStartFromVisualInspectionOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12" v-if="false">
                  <el-form-item style="float: right; color: red" label=""
                    >{{ "*选择是代表需要外检员检测完毕后引车员才开始引车" }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="最多检车数"
                    :label-width="formLabelWidth"
                    prop="MaxNum"
                  >
                    <el-input
                      v-model="model.MaxNum"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="最多停车数"
                    :label-width="formLabelWidth"
                    prop="ParkNumber"
                  >
                    <el-input
                      v-model="model.ParkNumber"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item
                    label="简介"
                    :label-width="formLabelWidth"
                    prop="SimpleDesc"
                  >
                    <el-input
                      v-model="model.SimpleDesc"
                      maxlength="500"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="描述"
                    :label-width="formLabelWidth"
                    prop="Description"
                  >
                    <el-input
                      v-model="model.Description"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3" v-if="uploadFileList.length > 0">
                  <el-form-item
                    label="上传图片"
                    :label-width="formLabelWidth"
                  ></el-form-item>
                </el-col>

                <el-col :span="21" v-if="uploadFileList.length > 0">
                  <el-upload
                    :class="{ hide: hideUpload }"
                    action="/api/UploadFile/UploadPictures"
                    list-type="picture-card"
                    :auto-upload="false"
                    :file-list="uploadFileList"
                    :limit="3"
                    style="padding-left: 20px"
                    ref="upload"
                  >
                  </el-upload>
                </el-col>
                <el-col :span="24" v-if="uploadFileList.length <= 0">
                  <el-form-item label="上传图片" :label-width="formLabelWidth">
                    <el-input value="无上传图片"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3" v-if="uploadStationLogo.length > 0">
                  <el-form-item
                    label="上传Logo"
                    :label-width="formLabelWidth"
                  ></el-form-item>
                </el-col>
                <el-col :span="21" v-if="uploadStationLogo.length > 0">
                  <el-upload
                    :class="{ hide: hideUpload }"
                    action="/api/UploadFile/UploadPictures"
                    list-type="picture-card"
                    :auto-upload="false"
                    :file-list="uploadStationLogo"
                    :limit="1"
                    ref="upload"
                    style="padding-left: 20px"
                  >
                  </el-upload>
                </el-col>

                <el-col :span="24" v-if="uploadStationLogo.length <= 0">
                  <el-form-item label="上传Logo" :label-width="formLabelWidth">
                    <el-input value="无上传logo图片"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <el-row>
        <el-button style="margin-left: 50px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      </el-row>-->
              <div style="margin-bottom: 15px"></div>
              <el-row
                type="flex"
                class="row-bg"
                justify="space-between"
                style="display: block; height: 305px"
              >
                <el-col :span="24">
                  <el-form-item
                    label="客户须知"
                    :label-width="formLabelWidth"
                    prop="FamilyAddress"
                  >
                    <!-- <el-input
              type="textarea"
              :rows="15"
              v-model="model.CustomerNotice"
              autocomplete="off"
            ></el-input> -->
                    <quill-editor
                      id="myeditor"
                      class="editor"
                      v-model="model.CustomerNotice"
                      ref="myQuillEditor"
                      :options="editorOption"
                      maxlength="900"
                      :disabled="true"
                      style="height: 205px"
                    >
                    </quill-editor>
                    <!-- @blur="onEditorBlur($event)"
              @focus="onEditorFocus($event)"
              @change="onEditorChange($event)" -->
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- <div style="height:10px;margin-bottom:55px"></div> -->
            </el-form>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="集团(协会)信息" v-if="form.UserType == 1">
        <span slot="label">集团(协会)信息</span>
        <div class="tab-content">
          <div class="tab-from-box">
            <el-form
              :model="groupModel"
              ref="form"
              class="form-box"
              :disabled="true"
            >
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    label="集团名称"
                    :label-width="formLabelWidth"
                    prop="GroupName"
                  >
                    <el-input
                      v-model="groupModel.GroupName"
                      autocomplete="off"
                      maxlength="100"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="集团简称" :label-width="formLabelWidth">
                    <el-input
                      v-model="groupModel.GroupShortName"
                      autocomplete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="集团负责人"
                    :label-width="formLabelWidth"
                    prop="GroupPrincipal"
                  >
                    <el-input
                      v-model="groupModel.GroupPrincipal"
                      autocomplete="off"
                      maxlength="10"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="地址"
                    :label-width="formLabelWidth"
                    prop="Address"
                  >
                    <el-input
                      v-model="groupModel.Address"
                      autocomplete="off"
                      maxlength="500"
                      placeholder="请精确到市，否则经纬度会解析失败"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="经度"
                    :label-width="formLabelWidth"
                    prop="LocationLng"
                  >
                    <el-input
                      :value="groupModel.LocationLng"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="纬度"
                    :label-width="formLabelWidth"
                    prop="LocationLat"
                  >
                    <el-input
                      v-model="groupModel.LocationLat"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="3" v-if="uploadGroupLogo.length > 0">
                  <el-form-item
                    label="上传Logo"
                    :label-width="formLabelWidth"
                  ></el-form-item>
                </el-col>
                <el-col :span="21" v-if="uploadGroupLogo.length > 0">
                  <el-upload
                    :class="{ hide: hideUpload }"
                    action="/api/UploadFile/UploadPictures"
                    list-type="picture-card"
                    :auto-upload="false"
                    :file-list="uploadGroupLogo"
                    :limit="1"
                    style="padding-left: 20px"
                    ref="upload"
                  >
                  </el-upload>
                </el-col>
                <el-col :span="24" v-if="uploadGroupLogo.length <= 0">
                  <el-form-item label="上传Logo" :label-width="formLabelWidth">
                    <el-input value="无上传logo图片"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <div style="margin-bottom: 10px"></div>
              <!-- 集团简介 -->
              <el-row
                id="groupduc"
                type="flex"
                class="row-bg"
                justify="space-between"
                style="display: block; height: 205px"
              >
                <el-col :span="24">
                  <el-form-item
                    label="集团简介"
                    :label-width="formLabelWidth"
                    prop="GroupIntroduction"
                  >
                    <el-input
                      type="textarea"
                      :rows="7"
                      v-model="groupModel.GroupIntroduction"
                      autocomplete="off"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getImgFolderConfig } from "@/js/globalConfig.js";
var token = sessionStorage.getItem("token"); // 要保证取到
import { quillEditor } from "vue-quill-editor";
export default {
  data() {
    return {
      form: {},
      formLabelWidth: "120px",
      weChatform: {
        NickName: "",
        AvatarUrl: "",
      },
      isBind: false,
      model: {
        StationCode: "", //检测机构名称
        StationName: "", //检测机构名称
        StationSerialNumber: "", //检验机构编号
        StationShortName: "", //检测站简称
        Address: "", //地址
        LocationLng: "", //经度
        LocationLat: "", //纬度
        DivisionCode: "000000",
        MaxNum: "", //最多检车数
        ParkNumber: "", //最多停车数
        Contact: "", //联系人
        Mobile: "", //手机号码
        ServiceTel: "", //客服电话
        Email: "", //邮箱
        ContactNumber: "", //联系电话
        ImageUrls: "", //图片地址拼成串，“,”分割
        SimpleDesc: "", //简介
        Description: "", //描述
        CustomerNotice: "",
        DriverStartFromVisualInspection: 0, //引车员引车是否从外检完毕开始
        LogoUrl: "",
      },
      groupModel: {
        GroupCodeStr: "", //集团编码
        GroupName: "", //集团名称
        GroupPrincipal: "", //集团负责人
        Division: "", //所属区划
        Address: "", //地址
        LocationLng: "", //经度
        LocationLat: "", //纬度
        GroupIntroduction: "", //集团简介
        LogoUrl: "",
      },
      editorOption: {
        placeholder: "无文本信息...",
        modules: {
          toolbar: [],
        },
      },
      GroupInfos: "",
      uploadFileList: [], //目前上传的图片列表，转成用逗号分隔的字符串赋值给model
      uploadGroupLogo: [], //集团Logo
      uploadStationLogo: [],
      hideUpload: true,
      DriverStartFromVisualInspectionOptions: [
        { label: "否", value: false },
        { label: "是", value: true },
      ],
    };
  },
  props: ["dialogVisible", "dialogTitle"],

  created() {},
  mounted() {
    //读取角色列表
    this.LoadData();
  },
  methods: {
    //获取绑定状态
    getBindStatus() {
      this.$axios
        .post("/WeChatLogin/GetBindWeChatCustomerInfo")
        .then((result) => {
          if (result.data.Code == "10000" && result.data.Data != null) {
            //按钮启用
            this.isBind = true;
            this.weChatform.NickName = result.data.Data.NickName;
            this.weChatform.AvatarUrl = result.data.Data.AvatarUrl;
          } else {
            this.isBind = false;
          }
        });
    },

    LoadData() {
      //查询所有角色
      var vm = this;
      this.loading1 = true;
      this.$axios
        .post("/Login/GetLoginUserInfo", {})
        .then(
          function (res) {
            if (res.data.Code == "10000") {
              this.form = res.data.Data.UserInfo;
              this.GroupInfos = res.data.Data.GroupInfos;
              if (this.form.UserType == 2) {
                this.model = res.data.Data.StationInfo;
                // console.log("检测站信息");
                // console.log(this.model);
                //将图片路径重新组织
                if (this.model.ImageUrls) {
                  // console.log(this.$store.state.globalConfig.ImgFolderPath);
                  this.model.ImageUrls.split(",").forEach((imgName) => {
                    this.uploadFileList.push({
                      name: imgName,
                      url:
                        this.$store.state.globalConfig.ImgFolderPath + imgName,
                    });
                  });
                }

                if (this.model.LogoUrl) {
                  this.model.LogoUrl.split(",").forEach((imgName) => {
                    this.uploadStationLogo.push({
                      name: imgName,
                      url:
                        this.$store.state.globalConfig.ImgFolderPath + imgName,
                    });
                  });
                }
              } else if (this.form.UserType == 1) {
                this.groupModel = res.data.Data.GroupInfo;
                if (this.groupModel.LogoUrl) {
                  // console.log(this.$store.state.globalConfig.ImgFolderPath);
                  this.groupModel.LogoUrl.split(",").forEach((imgName) => {
                    this.uploadGroupLogo.push({
                      name: imgName,
                      url:
                        this.$store.state.globalConfig.ImgFolderPath + imgName,
                    });
                  });
                }
              }
              let userInfo = this.$store.getters["user/UserInfo"];
              this.form.StationName = userInfo.StationName;
            }
          }.bind(this)
        ) //bind(this)可以不用
        .catch(
          function (err) {
            if (err.response) {
              this.$message({
                message: "服务器端错误，数据加载失败！",
                type: "error",
              });
              this.loading = false;
            }
          }.bind(this)
        ); //bind(this)可以不用
    },
    opened() {
      this.getBindStatus();
    },
    //离开标签页钩子
    leaveTab(activeName, oldActiveName) {},
    dialogClose() {
      this.$emit("dialogClose", false);
      this.resetForm("form");
    },
    tigMsgClose(value) {
      this.tipOptions.visible = value;
      console.info(this.isSuccess);
      if (this.isSuccess) this.$emit("dialogClose", false);
    },
    //弹出框的取消按钮
    tipMsgCancel: function () {
      this.tipOptions.visible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    test() {
      alert(123);
    },
  },
  components: {
    quillEditor,
  },
};
</script>

<style scoped>
.view_scroll-box >>> .el-input--suffix .el-input__inner {
  padding-left: 12px !important;
}
.view_scroll >>> .el-input--suffix .el-input__inner {
  padding-right: 12px !important;
}
/*覆盖ant-design-vue 样式**/
/* .el-input__inner[disabled] {
  color: rgba(0, 0, 0, 0.6);
  background-color: #f9f9f9;
}

.ant-select-disabled {
  color: rgba(0, 0, 0, 0.6);
}
.ant-select-disabled .ant-select-selection {
  background: #f9f9f9;
  cursor: not-allowed;
} */

#userinfo >>> .hide .el-upload--picture-card {
  display: none;
}
#userinfo >>> .ql-toolbar {
  height: 0px !important;
  padding: 0px !important;
  border-bottom: 0px !important;
}
#userinfo >>> .ql-editor {
  color: rgba(0, 0, 0, 0.6) !important;
  background-color: #f9f9f9 !important;
}
/*覆盖ant-design-vue 样式**/
#userinfo >>> .el-input__inner[disabled] {
  color: rgba(0, 0, 0, 0.6) !important;
  background-color: #f9f9f9 !important;
}
#userinfo >>> .el-textarea__inner[disabled] {
  color: rgba(0, 0, 0, 0.6) !important;
  background-color: #f9f9f9 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/permission/user/userInfo.vue